/*
 * Copyright (c) 2022-2024. Haodong JU
 */

// import GlobalSettings from '@/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'
import PrintNameEntity from '@/model/dataLayer/api/buffet/PrintNameEntity'
import { defaultLanguage } from '@/model/global/DefaultLanguage'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      requiredNew: false
    },
    form: false,
    header: false
  },

  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'name',
      default: defaultLanguage(),
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang().toUpperCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name', 'printName'],
    labelKey: 'lang',
    children: [
      PrintNameEntity, PrintNameEntity, PrintNameEntity
    ]
  },
  color: {
    displayName: 'color',
    tableConfig: {
      width: '60px'
    },
    type: IKDataEntity.Types.Color
  },
  zbonGroup: {
    displayName: 'zbonGroup',
    formConfig: {
      default: 100,
      required: false
    },
    header: false,
    form: false
  }

}
const config = {
  load: async function (filter) {
    const response = (await hillo.get('Complex.php', {
      op: 'showAllConsumeTypeInfo',
      lang: GlobalSettings.getLang(),
      ...filter
    }))
      .content
    response.forEach(i => {
      i.langs = Object.values(i.langs)
      i.localName = i.langs.find(it => it.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase())?.name ?? i.name
    })
    return response
  },
  add: function (item) {
    item.name = item.langs[2].name
    item.zbonGroup = 100
    return hillo.post('ConsumeType.php?op=add', {
      ...item,
      langs: JSON.stringify(item.langs)
    }, {
      showLoading: false
    })
  },
  edit: function (item) {
    if (item.name !== 'BBH') {
      item.name = item.langs[2].name
    }
    return hillo.postWithUploadFile('ConsumeType.php?op=update', {
      ...item,
      langs: JSON.stringify(item.langs)
    })
  },
  remove: function (id) {
    return hillo.post('ConsumeType.php?op=softDelete', { id })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
